export class AllocationViewAvailableDocksLoad {
  public static readonly type = '[AllocationViewAvailableDocks] Load';
  constructor(public payload: number) {}
}

export class AllocationViewAvailableDocksInitialState {
  public static readonly type = '[AllocationViewAvailableDocks] Set Initial State';
}
